import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogle = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "b1b07434-ee94-4070-ae64-f1b199566622",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 18 18",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "b3ff6d4b-40a8-4727-bc6e-d2d0441e90f3",
		"data-name": "Google-Button",
		children: /* @__PURE__ */ _jsx("g", {
			id: "a742a927-7270-48d4-9799-6c2cbe9f44c1",
			"data-name": "btn google light normal",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "a7b0e4cd-9e0a-4b46-b0a7-4e035cd7b969",
				"data-name": "logo googleg 48dp",
				children: [
					/* @__PURE__ */ _jsx("path", {
						id: "ac2d5a2f-3431-405f-a9c3-e6d1a4f762bb",
						"data-name": "Shape",
						d: "M17.64,9.2a11,11,0,0,0-.16-1.84H9v3.49h4.84a4.12,4.12,0,0,1-1.79,2.71v2.26H15A8.78,8.78,0,0,0,17.64,9.2Z",
						style: {
							fill: "#4285f4",
							fillRule: "evenodd"
						}
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "fa48fca0-1360-4f8f-a82b-93b7f3150b15",
						"data-name": "Shape",
						d: "M9,18a8.62,8.62,0,0,0,6-2.18l-2.91-2.26A5.43,5.43,0,0,1,9,14.42a5.37,5.37,0,0,1-5-3.71H1V13a9,9,0,0,0,8,5Z",
						style: {
							fill: "#34a853",
							fillRule: "evenodd"
						}
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "a26a61d9-d5b9-4001-ab25-a456a633ccbe",
						"data-name": "Shape",
						d: "M4,10.71A5.36,5.36,0,0,1,4,7.29V5H1A9,9,0,0,0,1,13l3-2.33Z",
						style: {
							fill: "#fbbc05",
							fillRule: "evenodd"
						}
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "a9c44df8-1f2e-4104-8cd2-1ad76a5708d9",
						"data-name": "Shape",
						d: "M9,3.58a4.83,4.83,0,0,1,3.44,1.35L15,2.34A8.65,8.65,0,0,0,9,0,9,9,0,0,0,1,5L4,7.29A5.37,5.37,0,0,1,9,3.58Z",
						style: {
							fill: "#ea4335",
							fillRule: "evenodd"
						}
					})
				]
			})
		})
	})
});
export default SvgGoogle;
